import React from 'react'

import classnames from 'classnames'
import store from '../../admin/store'
import Button from '../../front/components/shared/sn-button'
import SnIcon from '../../front/components/shared/sn-icon'
import i18n from '../../locales/i18n'
import { setRedirectUrl } from '../../admin/actions/auth'
import { setSystemRedirectLinks } from '../../admin/actions/system-redirect'
import { SFN_TYPE } from '../../consts'
import { getRemoteLoginLink } from '../auth/remote-login-redirect'

/**
 * Set success login action - redirect back - inside store and session storage
 */
export const setSuccessAction = () => {
    const currentPath = window.location.href

    store.dispatch({
        type: 'SET_SUCCESS_LOGIN_ACTION',
        successAction: () => window.location.href = currentPath,
    })

    setRedirectUrl(currentPath)

    sessionStorage.setItem('facebookLogin.redirectPath', currentPath)
}

/**
 * Render login button
 *
 * @param {Object} props
 * @return {*}
 * @constructor
 */
export const LoginButton = props => (
    <Button
        className="icon-link"
        href={props?.fromSfn ? ('/login' + SFN_TYPE) : {
            pathname: '/login',
        }}
        onClick={setSuccessAction}
    >
        <SnIcon className="sn-avatar" />
        <p>{i18n.t('signIn')}</p>
    </Button>
)

/**
 * Render login button for cities
 *
 * @return {*}
 * @constructor
 */
export const CitiesLoginButton = () => {
    const handleClick = () => {
        setSuccessAction()
        setSystemRedirectLinks(null, getRemoteLoginLink(), true)
    }

    return (
        <div
            className="icon-link ml-2 mr-2 mx-sm-0"
            onClick={handleClick}
        >
            <SnIcon className="sn-avatar" />
            <p>{i18n.t('signIn')}</p>
        </div>
    )
}

/**
 * Render sign up button
 *
 * @param {Object} props
 * @return {*}
 * @constructor
 */
export const SignUpButton = props => (
    <Button
        href={props?.url || {
            pathname: '/signup',
        }}
        target={props?.buttonOutside ? '_blank' : ''}
        onClick={setSuccessAction}
        className={classnames({
            'btn btn-color-brand btn-xl btn-circle Landing-main-box__button': true,
            [props?.className]: !!props?.className,
        })}
    >
        {props.children || i18n.t('joinIn')}
    </Button>
)
